import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class GetTenantLeaseError extends CodedError {
  static get errorName() {
    return errorCodeTypes.getTenantLeaseError.code;
  }

  constructor(message = errorCodeTypes.getTenantLeaseError.message) {
    super(message);
    this.code = errorCodeTypes.getTenantLeaseError.code;
    this.message = `${message} ${errorCodeTypes.getTenantLeaseError.code}`;
    this.name = errorCodeTypes.getTenantLeaseError.name;
  }
}
